/*
* Site Scrolled fill rest of NAV 
*/

$(document).ready(function($) {

    'use strict';
    var navbar = $(".mainnav");

    $(window).scroll(function () {
        var a = $(window).scrollTop();

        if (a > 60) {
            navbar.addClass("mainnav_scrolled");
        } else {
            navbar.removeClass("mainnav_scrolled");
        }
    });
});